import getPartner from 'API/Partner/getPartnerList';
import { useQuery } from 'hooks/useCustomQuery';

const useGetPartnerList = async (
    currentWholesaler,
    currentScope,
    setPartnerList,
    enabled = true,
) => {
    return useQuery({
        queryKey: ['partnerList'],
        queryFn: async () => {
            try {
                const res = await getPartner(currentWholesaler, currentScope);
                setPartnerList(res.data);
                return res.data;
            } catch (error) {
                throw new Error('Error fetching partner list');
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled,
    });
};

export default useGetPartnerList;
